import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'NgxWrist-NgxAnalogWristWatch',
  template: `
    <p>
      ngx-analog-wrist-watch works!
    </p>
  `,
  styles: []
})
export class NgxAnalogWristWatchComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
